<ng-container *ngIf="model">
  <div
    [dragAndDrop]="dragAndDrop ? dragData : null"
    [pTooltip]="model?.tooltip"
    tooltipPosition="bottom"
    tooltipStyleClass="u-tooltip"
    class="attachment"
    [ngClass]="{
      active: contextMenuOpened,
      'no-text': !model.text,
      'show-copied': showCopied,
      'preview-attachment': previewAttachment
    }"
  >
    <u-icon *ngIf="model.icon && !hideIcon" [model]="iconModel" class="attachment-icon"></u-icon>
    <span *ngIf="model.caption">{{ model.caption }}:&nbsp;</span>
    <span *ngIf="model.text" [ngStyle]="{ color: model.textColor }" class="text" #wrapperContainer data-cy="mail-preview-attachment-text">
      <span [ngClass]="{ preview: isPreview }" #attachment>
        {{ splittedText }}
      </span>
    </span>
    <span class="copy-ind">Copied!</span>
  </div>
</ng-container>
